export default __webpack_public_path__ + "static/media/icon-warning.a9887b83.svg";